import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react'
import jwt_decode from "jwt-decode";
import { Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CardInput from '../../atomic/paymentOptions/CardInput'
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import { CREDIT_CARD_TITLE, CREDIT_CARD_SUBTITLE, API_NETWORK_ERROR, localStorageKeys } from "../../global/constants";
import isCardExpired from "../../global/isCardExpired";
import "./YourPaymentMethod.scss";
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import AtomicButton from '../../atomic/button/AtomicButton';
import responseErrorMapping from './../../global/error.response.mapping'
import { Error404 } from '../Error404/Error404';
import { CreditCardIcons } from './../../global/assets/Icons'
import fallBackImage from "../../global/assets/svg/ImageError.svg";
import { SignUpInfoDataContext } from '../../context-api/SignUpInfoDataProvider';



// YourPaymnetMenthod Component is used in customer account pages 
const YourPaymentMethod = ({ children }) => {
    const navigate = useNavigate();

    const { TOKEN, DEBUG_LOGOUT_POINT } = localStorageKeys;
    const setLocalStorageDebug = async (param1, param2) => localStorage.setItem(param1, param2)
    const hasTokens = localStorage.getItem(TOKEN);

    const { isLoggedIn, onLogout,
        customerInfoData,
        onCustomerInformationApiHandler,
        onUpdateCreditCard,
        updateCreditCardData,
        setUpdateCreditCardData } = useContext(LoginDataContext);


    const singnUpContext = useContext(SignUpInfoDataContext);
    const {
        setSignUpformValues,
        signUpformValues,
        expiryMonth,
        expiryYear,
        cvcValue,
        setCardNumber,
        setExpiryMonth,
        setExpiryYear,
        setCvcValue
    } = singnUpContext;
    const [openAddCreditCard, setOpenAddCreditCard] = useState(true)
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [loader, setLoader] = useState(false)
    const { loading, data, success, errorMessage } = updateCreditCardData
    const decodedToken = jwt_decode(hasTokens);
    const { email } = decodedToken
    const { success: checkSuccess, loading: checkLoading, data: checkData, errorMessage: checkMessage, noKitchensFound } = customerInfoData
    const MobileIpadClass = isMobile || isIpad
    const cardInformation = checkData?.data?.card_info || {};
    const cardValiditity = isCardExpired(cardInformation?.exp_month, cardInformation?.exp_year)
    const custInfo = checkData?.data?.user_Info?.reason_status === 'Card decline'
    const [cardDetailMissing, setCardDetailMissing] = useState(false)

    const { card_number, exp_month, exp_year, cvc,
    } = signUpformValues



    const apiCallCustomerInfo = async () => {
        await onCustomerInformationApiHandler()
    };

    useEffect(() => {
        if (isLoggedIn) {
            apiCallCustomerInfo()
        }
    }, [])


    const triggerLogout = async () => {
        await onLogout()
        navigate('/login')
        window.location.reload()
    }

    const onImageLoad = () => {
        setImageLoaded(true);
    };

    const onImageError = () => {
        setImageError(true);
        setImageLoaded(true);
    };



    const handleOpen = async () => {
        setUpdateCreditCardData({})
        setSignUpformValues({})
        if (!openAddCreditCard) {
            setOpenAddCreditCard(true)

        }
        if (openAddCreditCard) {
            setOpenAddCreditCard(false)
        }

    }


    useEffect(() => {
        if (success) {
            setOpenAddCreditCard(true)
            apiCallCustomerInfo()
            setCardNumber(null)
            setExpiryMonth(null)
            setExpiryYear(null)
            setCvcValue(null)
        }

    }, [updateCreditCardData])



    const handleSubmit = async (e) => {
        setUpdateCreditCardData({})
        //console.log('cvc', cvcValue, 'exp_year', expiryMonth, 'exp_month', expiryYear);

        if (((cvcValue === undefined || cvcValue.length < 3)
            || (expiryYear === undefined || expiryYear.length < 4)
            || (expiryMonth === undefined || expiryMonth.length < 2))) {
            setCardDetailMissing(true);
        } else {
            setCardDetailMissing(false);
            const cardResponse = await onUpdateCreditCard({
                email: email,
                payment_card: {
                    card_number: card_number,
                    exp_month: exp_month,
                    exp_year: exp_year,
                    cvc: cvc
                }
            })


            if (cardResponse?.data?.success === true) {
                setSignUpformValues({})
            }

        }
        return
    };





    // We should capture this if block errors in new relic
    if (checkSuccess === false && checkMessage === 'Token & Refresh Token missing') {
        setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'YourPaymentMethod NO9997')
        triggerLogout()
        return
    }


    // We should capture this if block errors in new relic
    if ((success === false && errorMessage === API_NETWORK_ERROR)
        || (checkSuccess === false && checkMessage === API_NETWORK_ERROR)
        || (checkMessage?.success === false && checkMessage?.CustomMessage === "Something is seriouly wrong,This is last CATCH block")) {
        return (<Error404 />)
    }


    return (
        <div style={isMobile ? { margin: '15px 0px 15px 15px' } : { margin: '10px 0px 10px 0px' }}>
            <div > {children}</div>
            <div className={MobileIpadClass ? "credit-card-title-mobile" : "credit-card-title-desktop"}>{CREDIT_CARD_TITLE}</div>
            <div className={MobileIpadClass ? "credit-card-sub-title-mobile" : "credit-card-sub-title-desktop"}>{CREDIT_CARD_SUBTITLE}</div>
            <button className={MobileIpadClass ? "button-style-credit-card-mobile" : "button-style-credit-card-desktop"} onClick={handleOpen}> {openAddCreditCard ? "Update Card" : "Cancel update"} </button>


            {success && <Alert

                severity="success"
                sx={{ backgroundColor: 'white', width: isMobile ? 'calc(100% - 48px)' : "475px", border: "solid 1px green", color: 'green', marginBottom: "10px", }}
            >
                <div>Successfully added!</div>
            </Alert>}



            {(success === false || cardDetailMissing === true) && <Alert
                severity="error"
                sx={{ backgroundColor: 'white', width: isMobile ? 'calc(100% - 48px)' : "475px", border: "solid 1px red", marginBottom: "10px", color: '#EE6969' }}
            >
                {!cardDetailMissing && <div>{responseErrorMapping(errorMessage)}</div>}

                {cardDetailMissing && <div> Payment detail missing</div>}
            </Alert>}



            {openAddCreditCard && <div className={MobileIpadClass ? "card-details-container-mobile" : "card-details-container-desktop"}>

                <img
                    width={imageLoaded ? "40px" : '40px'}
                    src={imageError ? fallBackImage : CreditCardIcons[cardInformation?.brand?.toLowerCase()] || CreditCardIcons['fallback icon']}
                    onLoad={() => onImageLoad()}
                    onError={() => onImageError()}
                    onClick={() => {
                        // console.log("image clicked pdp desktop");
                    }}
                />
                <div style={{ marginLeft: '20px', textTransform: 'capitalize' }}> {cardInformation?.brand}</div>
                <div style={{ marginLeft: '10px', }}> .... {cardInformation?.last4}</div>

                {
                    !custInfo && <div style={{ flex: 1, textAlign: 'right', color: cardValiditity === "active" ? 'green' : 'red', textTransform: 'capitalize' }}> {cardValiditity}</div>

                }
                {
                    custInfo && <div style={{ flex: 1, textAlign: 'right', color: 'red', }}> Card declined !</div>

                }



            </div>
            }
            {!openAddCreditCard && (

                <>
                    <CardInput />
                    <AtomicButton
                        label={loader ? "...Updating card" : "Update card"}
                        loadingButtonStyle={{ width: isMobile ? 'calc(100% - 10px)' : '508px', height: '40px' }}
                        style={{
                            backgroundColor: `#181436`,
                            width: isMobile ? 'calc(100% - 70px)' : '450px',
                            fontSize: '14px',
                            height: '40px',
                            margin: '15px 0px 0px 15px'

                        }}
                        handleSubmit={handleSubmit}
                        endIcon={''}
                        startIcon={''}
                        loading={loading}
                        disabled={loading}
                    />
                </>
            )}
        </div>
    )
}

export default YourPaymentMethod